module.exports = __webpack_public_path__ + "static/media/bell.6b4160fa.svg";